  <template>
    <div>
    <div class="flex infline-flex">
        <img class="mt-10" style="display: block;
            margin-left: auto;
            margin-right: auto;
            width:100px;
            height:100px;" alt="Vue logo" src="@/assets/fas_logo.png">
        <img class="mt-10" style="display: block;
            margin-left: auto;
            margin-right: auto;
            width:200px;
            height:100px;" alt="Vue logo" src="@/assets/Seccion_17_vector.png">
    </div>
    <div>
      <p class="text-4xl text-center text-goodGreen font-bold w-full mt-5">Fondo de Ayuda Sindical</p>
    </div>
    </div>
</template>

<script>
export default {
  name: 'Header',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>
